export default "__VITE_ASSET__fb47828e__"